module.exports = __webpack_public_path__ + "img/student.9fc1db23.png";